import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import DigitizeImg from "../../../images/location_new/fold5/ios-uk.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Partner with the Right iOS App Development Company in London to
              Digitize Your Business
            </h2>
            <p>
              TekRevol stands as a leading iPad app development company,
              offering transformative solutions. Our skilled iOS application
              developers in London are adept at elevating businesses. What sets
              us apart is our commitment to excellence and understanding the
              importance of cost-effectiveness. We provide competitive rates for
              app development in the UK without compromising quality.
            </p>
            <p>
              Partner with us, the right iOS app development agency in London,
              to digitally transform your business.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="ios-app-development-company-london"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
